module.exports = __webpack_public_path__ + "static/media/button_up.802b4545.svg";